import React from "react";
import useRouteUtils from "../../utils/hooks/useRouteUtils";
import { useSelector } from "react-redux";
import { useMemo } from "react";

const useReports = () => {
  const { checkIfActiveRoute } = useRouteUtils();
  const globalState = useSelector((state) => state.global);
  const drawerMenu = [
    {
      title: "RLM 1",
      link: "/reports",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined x4"> group </span>,
      active: checkIfActiveRoute("/reports", true),
    },
    {
      title: "RLM 2",
      link: "/reports/rlm2",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined x4"> group </span>,
      active: checkIfActiveRoute("/reports/rlm2", true),
    },
    {
      title: "RLM 3",
      link: "/reports/rlm3",
      iconAsset: "DrawerIcon3",
      icon: (
        <span className="material-symbols-outlined x4">workspace_premium</span>
      ),
      active: checkIfActiveRoute("reports/rlm3"),
    },
    {
      title: "Purchase Register",
      link: "/reports/purchase-register-report",
      iconAsset: "DrawerIcon3",
      icon: (
        <span className="material-symbols-outlined x4">workspace_premium</span>
      ),
      active: checkIfActiveRoute("reports/purchase-register-report"),
    },
  ];
  // const drawerMenuPermission = useMemo(() => {
  //   let menus = globalState.dashboard_permissions?.flatMap?.((menu) => [
  //     ...menu.permissions.map((sub_menu) => sub_menu.menu_name),
  //   ]);

  //   menus = ["RLM 2", "RLM 3"];

  //   return drawerMenu
  //     .filter((menu) => menus?.includes?.(menu.title))
  //     .map((menu) => {
  //       return {
  //         ...menu,
  //       };
  //     });
  //   //eslint-disable-next-line
  // }, [globalState.dashboard_permissions, location.pathname]);


  return {
    drawerMenu
  };
};

export default useReports;
